class featuredVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const videoThumbnail = this.querySelector(".video-thumbnail")
    const { videoType, videoId } = this.dataset;

    videoThumbnail.addEventListener("click", function() {
      if(videoType === "youtube") {
        const videoEmbed = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="position:absolute; top:0; left:0; width:100%; height:100%;"></iframe>`
        this.innerHTML = videoEmbed;
      } else if (videoType === "vimeo") {
        const videoEmbed = `<iframe class="Image--lazyLoad" data-src="//player.vimeo.com/video/${videoId}?autoplay=1&portrait=0&byline=0" frameborder="0" style="position:absolute; top:0; left:0; width:100%; height:100%;"></iframe>`
        this.innerHTML = videoEmbed;
      }
    });
  }
}
customElements.define('featured-video', featuredVideo);
